import { render, staticRenderFns } from "./link.vue?vue&type=template&id=21e7fe8c&scoped=true&"
import script from "./link.ts?vue&type=script&lang=ts&"
export * from "./link.ts?vue&type=script&lang=ts&"
import style0 from "./link.scss?vue&type=style&index=0&id=21e7fe8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e7fe8c",
  null
  
)

export default component.exports